import type { Page } from '~/types/api/page'

export const useWagtailApiPageGetByPath = (path: string) => useYscFetch<Page>(`/api/v1/pages/find/?html_path=${path}`)
